export default {
  SET_CURRENT_OPEN_MENU: 'SET_CURRENT_OPEN_MENU',
  SET_CURRENT_MENU: 'SET_CURRENT_MENU',
  TOGGLE_SIDE_NAV: 'TOGGLE_SIDE_NAV',
  CURRENT_PROJECT_ID: 'CURRENT_PROJECT_ID',
  USER_INFO: 'USER_INFO',
  AUTH_URL_LIST: 'AUTH_URL_LIST',
  MENUS: 'MENUS',
  PERMISSIONS: 'PERMISSIONS',
  ROLES: 'ROLES',
  LOGOUT: 'LOGOUT',
  HOMEMENU: 'HOMEMENU',
  timeShowForWarehouse: 'timeShowForWarehouse',
};



// WEBPACK FOOTER //
// ./src/store/mutation-types.js